"use strict";
/**
 * pageopt
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var fieldtools_1 = __importDefault(require("../../src/modules/commonutil/fieldtools"));
var pagedata = window["pagedata"];
var pageopt = {
    //datekey:报告期，sortname报表默认排序字段，type：报表type参数
    dataconfig: {
        scgk: { type: "RPT_GOODWILL_MARKETSTATISTICS", showcount: 5, sortname: "REPORT_DATE", sortorder: "-1", filter: "((GOODWILL_STATE=\"1\")(|IMPAIRMENT_STATE=\"1\"))(TRADE_BOARD=\"all\")" },
        yqlist: { type: "RPT_GOODWILL_STOCKPREDICT", showcount: 5, sortname: "NOTICE_DATE,SECURITY_CODE", sortorder: "-1,-1", filter: "(REPORT_DATE='" + (pagedata === null || pagedata === void 0 ? void 0 : pagedata.datedef_yq.date) + "')" },
        list: { type: "RPT_GOODWILL_STOCKDETAILS", showcount: 5, sortname: "NOTICE_DATE,SECURITY_CODE", sortorder: "-1,-1", filter: "(REPORT_DATE='" + (pagedata === null || pagedata === void 0 ? void 0 : pagedata.datedef_mx.date) + "')" },
        jzlist: { type: "RPT_GOODWILL_STOCKDETAILS", showcount: 5, sortname: "GOODWILL_CHANGE", sortorder: "-1", filter: "(REPORT_DATE='" + (pagedata === null || pagedata === void 0 ? void 0 : pagedata.datedef_jz.date) + "')" },
        bzlist: { type: "RPT_GOODWILL_STOCKDETAILS", showcount: 5, sortname: "SUMSHEQUITY_RATIO", sortorder: "-1", filter: "(REPORT_DATE='" + (pagedata === null || pagedata === void 0 ? void 0 : pagedata.datedef_mx.date) + "')" },
        hylist: { type: "RPT_GOODWILL_INDUSTATISTICS", showcount: 5, sortname: "SUMSHEQUITY_RATIO", sortorder: "-1", filter: "(REPORT_DATE='" + (pagedata === null || pagedata === void 0 ? void 0 : pagedata.datedef_mx.date) + "')" }
    },
    columns: {
        "REPORT_DATE": emfield.date,
        "GOODWILL": emfield.num_trim_end,
        "GOODWILL_CHANGE": emfield.num_trim_end_c,
        "SUMSHEQUITY": emfield.num_trim_end,
        "SUMSHEQUITY_RATIO": { formatter: { num: 5521, omit: false, showcolor: true, zoom: 2 } },
        "SUMSHEQUITY_CHANGE_RATIO": { formatter: { num: 5521, omit: false, showcolor: true, zoom: 2 } },
        "PARENTNETPROFIT": emfield.num_trim_end_c,
        "PNP_CHANGE_RATIO": { formatter: { num: 5521, omit: false, showcolor: true, zoom: 2 } },
        "SECURITY_CODE": emfield.code,
        "SECURITY_NAME_ABBR": emfield.name,
        "xg_yjyg": {
            formatter: function (value, item, i, field) {
                return "<a class=\"red\" href=\"/sy/detail/" + item.SECURITY_CODE + ".html\">\u8BE6\u7EC6</a>&nbsp;\n                <a href=\"/bbsj/yjyg/" + item.SECURITY_CODE + ".html\">\u4E1A\u7EE9\u9884\u544A</a>&nbsp;\n                <a href=\"/stockdata/" + item.SECURITY_CODE + ".html\">\u6570\u636E</a>&nbsp;\n                <a href=\"//guba.eastmoney.com/list," + item.SECURITY_CODE + ".html\">\u80A1\u5427</a>";
            }
        },
        "xg_stock": {
            formatter: function (value, item, i, field) {
                return "<a class=\"red\" href=\"/sy/detail/" + item.SECURITY_CODE + ".html\">\u8BE6\u7EC6</a>&nbsp;\n                <a href=\"/stockdata/" + item.SECURITY_CODE + ".html\">\u6570\u636E</a>&nbsp;\n                <a href=\"/notices/stock/" + item.SECURITY_CODE + ".html\">\u516C\u544A</a>&nbsp;\n                <a href=\"//guba.eastmoney.com/list," + item.SECURITY_CODE + ".html\">\u80A1\u5427</a>";
            }
        },
        "PERFORM_CHANGE_EXPLAIN": emfield.title_25,
        "NEWEST_REPORT_DATE": emfield.date,
        "NEWEST_GOODWILL": emfield.num_trim_end,
        "PE_GOODWILL": emfield.num_trim_end,
        "PREDICT_NETPROFIT_UPPER": {
            formatter: function (value, item, i, field) {
                var str = "";
                if (item.PREDICT_NETPROFIT_LOWER != null) {
                    str += fieldtools_1["default"].fieldfmt(item.PREDICT_NETPROFIT_LOWER, { showcolor: true, num: 2 });
                }
                if (item.PREDICT_NETPROFIT_UPPER != null) {
                    if (item.PREDICT_NETPROFIT_LOWER == item.PREDICT_NETPROFIT_UPPER) {
                        return str;
                    }
                    if (item.PREDICT_NETPROFIT_LOWER != null)
                        str += "～";
                    str += fieldtools_1["default"].fieldfmt(item.PREDICT_NETPROFIT_UPPER, { showcolor: true, num: 2 });
                }
                ;
                if (item.PREDICT_NETPROFIT_LOWER == null && item.PREDICT_NETPROFIT_UPPER == null) {
                    str = "-";
                }
                return str;
            }
        },
        "PERFORM_CHANGE_UPPER": {
            formatter: function (value, item, i, field) {
                var str = "";
                if (item.PERFORM_CHANGE_LOWER != null) {
                    str += fieldtools_1["default"].fieldfmt(item.PERFORM_CHANGE_LOWER, { omit: false, fix: '%', showcolor: true, num: 2 });
                }
                if (item.PERFORM_CHANGE_UPPER != null) {
                    if (item.PERFORM_CHANGE_LOWER == item.PERFORM_CHANGE_UPPER) {
                        return str;
                    }
                    if (item.PERFORM_CHANGE_LOWER != null)
                        str += "～";
                    str += fieldtools_1["default"].fieldfmt(item.PERFORM_CHANGE_UPPER, { omit: false, fix: '%', showcolor: true, num: 2 });
                }
                ;
                if (item.PERFORM_CHANGE_LOWER == null && item.PERFORM_CHANGE_UPPER == null) {
                    str = "-";
                }
                return str;
            }
        },
        "PE_SAMEREPORT_NETPROFIT": emfield.num_trim_end_c,
        "NOTICE_DATE": emfield.date,
        "SE_CHANGE_RATIO": { formatter: { num: 5521, omit: false, showcolor: true, zoom: 2 } },
        "PNP_YOY_RATIO": { formatter: { num: 5521, omit: false, showcolor: true, zoom: 2 } },
        "GOODWILL_PRE": emfield.num_trim_end,
        "INDUSTRY_NAME": emfield.string,
        "ORG_NUM": emfield.string,
        "PREDICT_TYPE": emfield.string
    }
};
window["pageopt"] = pageopt;
exports["default"] = pageopt;
